import { ChildrenProp } from '@unipile/ui';

export default function Layout({ children }: ChildrenProp) {
  return (
    <div className="bg-muted/20 flex min-h-screen flex-col items-center justify-center">
      <div className="w-full max-w-[500px] px-[2rem]">{children}</div>
    </div>
  );
}
